import { render, staticRenderFns } from "./UpsertEmployee.vue?vue&type=template&id=b6a49b5c&scoped=true"
import script from "./UpsertEmployee.vue?vue&type=script&lang=js"
export * from "./UpsertEmployee.vue?vue&type=script&lang=js"
import style0 from "./UpsertEmployee.vue?vue&type=style&index=0&id=b6a49b5c&prod&lang=css&scoped=true"
import style1 from "./UpsertEmployee.vue?vue&type=style&index=1&id=b6a49b5c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6a49b5c",
  null
  
)

export default component.exports